import http from './base/http';
import Config from '@/config';

export const log = async <T>(type, data) => {
  const url = `${Config.BFF_SERVICE.URL}/hainan-logger/log/${type}`;
  const headers = {};

  try {
    return await http.post<BFFResponse<any>>(url, data, { headers });
  } catch (error) {
    //
  }
};
